<template>
    <div class="table_wrap">
        <span class="total_length">총 {{ paginationData.total }}개 </span>
        <el-table :data="pointData"
                  class="list-table"
                  header-cell-class-name="list-header"
                  empty-text="데이터가 없습니다."
                  height="695"
        >
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    width="90"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column
                    class="table_no"
                    label="결제번호"
                    prop="p_uuid"
                    width="180"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column
                    label="상태" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnPointType(scope.row.pd_code) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column min-width="200" label="내용"  class-name="text-center"> 
                <template slot-scope="scope">
                    <span>
                        {{ returnReason(scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column min-width="155" label="사용 밍글" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnPlus(scope.row.p_point) }}M({{ returnWon(scope.row.p_point) }})
                    </span>
                </template>
            </el-table-column>
            <el-table-column min-width="155" label="현재 밍글" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ returnPoint(scope.row.p_point_history, scope.row.p_point) }}M( ₩{{
                            returnNowWon(scope.row.p_point_history, scope.row.p_point)
                        }})
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="일자" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.created_at }}
                    </span>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>

<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import {pointStatus} from "@/service/pointService";

export default {
    name: "PointListHistoryLayout",
    mixins: [dateMixins, alertMixins],
    components: {},
    inject: {
        setPage: {
            default: () => {
            }
        },

        setFilter: {
            default: () => {
            }
        },
    },
    provide() {
        return {}
    },
    props: {
        pointType: '',
        pointData: {
            default: () => {
                return []
            }
        },
        paginationData: {
            type: Object,
            default: () => {
                return {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            }
        },
    },
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        returnDate(date = null) {
            if (!date) {
                return '';
            }
            return this.$moment(date).format('YYYY-MM-DD HH:mm')
        },
        tableIdx(index) {
            return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
        },
        returnPointType(status) {
            let index = pointStatus.findIndex(ds => ds.value === status);
            if (index > -1) {
                return pointStatus[index].name;
            }
            return '-';
        },
        returnPoint(pointHistory, point) {
            return this.returnCommas(pointHistory + point);
        },
        returnWon(point) {
            point = String(point + '0')
            if (point.charAt(0) == '-') {
                point = point.replace('-', '-₩')
            } else {
                point = "+₩" + point;
            }
            return this.returnCommas(point);
        },
        returnNowWon(pointHistory, point) {
            let nowPoint = pointHistory + point;
            nowPoint = nowPoint + '0';
            return this.returnCommas(nowPoint);
        },
        returnPlus(point) {
            if (point > 0) {
                point = "+" + point;
                return this.returnCommas(point);
            } else {
                return this.returnCommas(point);
            }
        },
        returnCommas(x = 0) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        returnReason(item){
            if(item.pd_code == 'UTILITY_BUY' || item.pd_code == 'UTILITY_SELL' || item.pd_code == 'UTILITY_REFUND' || item.pd_code == 'UTILITY_GIFT'){
                let name = item.hasOwnProperty('ExtraData')&& item.ExtraData[0] && item.ExtraData[0].u_name ? item.ExtraData[0].u_name : "";
                return name + " "+ item.p_reason;
            }else {
                return item.p_reason;
            }
        }
        // checkNum(row) {
        //   let num = Number(row.wr_seq);
        //   if(row.wr_seq === '' || !Number.isInteger(num)) {
        //     this.errorAlert('순서를 입력해주세요.')
        //     return false;
        //   }
        //   this.changeSeqData(row);
        // },
    },
    watch: {},
}
</script>

<style scoped>

</style>
